<template>
  <div class="main">
    <div class="menu_item left-align displayed" @click="openClose()">
      <i class="fa-solid fa-bars" style="font-size:32px" id="menu_bar_control"></i>
    </div>
    <div class="menu">
      <div class="item_menu"><img src="@/assets/logo.png" width="60" /></div>
      <div class="item_menu" v-for="item in menu_items" :key="item.name">
        <a @click.prevent="menuItem(item.name)">{{ item.apelido }}</a>
      </div>
      <div class="item_menu last"><NavSocial @alertMessage="handleAlertMessage" /></div>
    </div>
    <div class="content" :class="{ 'expanded-content': isPrivacyPolicyPage }">
      <component :is="elementPage" />
    </div>
    <!-- Footer -->
    <footer class="footer">
      <div class="container">
        <span class="copyright">&copy; {{ currentYear }} Templo EDEM. Todos os direitos reservados.</span>
        <span @click="elementPage = 'PrivacyPolicyPage'" style="cursor: pointer; text-decoration: underline;">Política de Privacidade</span>
      </div>
    </footer>
    <Whatsapp />
  </div>
</template>

<script>
import NavSocial from './NavSocial.vue';
import HomePage from './HomePage.vue';
import GirasPage from './GirasPage2.vue';
import AlakaPage from './AlakaPage.vue';
import FundamentosPage from './FundamentosPage.vue';
import MapPage from './MapPage.vue';
import Whatsapp from './WhatsappIconPage.vue';
import PrivacyPolicyPage from './PrivacyPolicyPage.vue';

export default {
  name: 'PrincipalPage',
  data() {
    return {
      menu_items: [
        { name: 'HomePage', apelido: 'HOME', path: {}, selecionado: false },
        { name: 'GirasPage', apelido: 'GIRAS', path: {}, selecionado: false },
        { name: 'AlakaPage', apelido: 'ALAKÁ', path: {}, selecionado: false },
        { name: 'FundamentosPage', apelido: 'FUNDAMENTOS', path: {}, selecionado: false },
        { name: 'MapPage', apelido: 'COMO CHEGAR', path: {}, selecionado: false }
      ],
      elementPage: 'HomePage',
      mediaQuery: window.matchMedia('(max-width: 922px)'),
      urlParams: window.location.pathname,
      currentYear: new Date().getFullYear()
    };
  },
  computed: {
    isPrivacyPolicyPage() {
      return this.elementPage === 'PrivacyPolicyPage';
    }
  },
  methods: {
    menuItem(name) {
      if (name === '') {
        name = 'HomePage';
      }
      this.menu_items.forEach(item => {
        item.selecionado = (item.name === name);
        if (item.selecionado) {
          this.elementPage = item.name;
          this.openClose();
        }
      });
    },
    openClose() {
      var menu = document.querySelector('.menu');
      var barra = document.querySelector('#menu_bar_control');
      
      // Simplificando a lógica
      if (window.innerWidth <= 922) {
        // Mobile: toggle simples entre mostrar e esconder
        if (menu.style.display === 'flex' || menu.style.display === '') {
          menu.style.display = 'none';
          barra.classList.remove('fa-xmark');
          barra.classList.add('fa-bars');
        } else {
          menu.style.display = 'flex';
          menu.style.flexDirection = 'column';
          barra.classList.remove('fa-bars');
          barra.classList.add('fa-xmark');
        }
      } else {
        // Desktop: menu sempre visível, apenas muda o ícone
        if (barra.classList.contains('fa-bars')) {
          barra.classList.remove('fa-bars');
          barra.classList.add('fa-xmark');
        } else {
          barra.classList.remove('fa-xmark');
          barra.classList.add('fa-bars');
        }
      }
    },
    
    // Simplificar também a função de mudança de media query
    handleMediaChange(e) {
      var menu = document.querySelector('.menu');
      var barra = document.querySelector('#menu_bar_control');
      
      if (e.matches) {
        // Mobile: esconder menu por padrão
        menu.style.display = 'none';
        barra.classList.remove('fa-xmark');
        barra.classList.add('fa-bars');
      } else {
        // Desktop: mostrar menu sempre
        menu.style.display = 'flex';
        menu.style.flexDirection = 'row';
        barra.classList.remove('fa-bars');
        barra.classList.add('fa-xmark');
      }
    },
    handleAlertMessage(message) {
      alert(message);
    }
  },
  components: {
    NavSocial,
    HomePage,
    GirasPage,
    AlakaPage,
    FundamentosPage,
    MapPage,
    Whatsapp,
    PrivacyPolicyPage
  },
  mounted() {
    if (this.urlParams) {
      if (this.urlParams.includes('index.html')) {
        var queryString = window.location.search;
        var urlParams = new URLSearchParams(queryString);
        this.urlParams = urlParams.get('param');
      }
      this.elementPage = this.urlParams.replace('/', '');
    }
    
    if (!this.elementPage || this.elementPage === "undefined") {
      this.elementPage = 'HomePage';
    }
    
    if (window.innerWidth <= 922) {
      this.mediaQuery = window.matchMedia('(max-width: 922px)');
    } else {
      this.mediaQuery = window.matchMedia('(min-width: 922px)');
    }
    
    this.mediaQuery.addEventListener('change', this.handleMediaChange);
  },
  beforeUnmount() {
    this.mediaQuery.removeEventListener('change', this.handleMediaChange);
  }
}
</script>

<style scoped>
.main {
  background-color: #f4cf5e;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

i:hover {
  cursor: pointer;
}

/* Footer */
.footer {
  background: #ffefbc;
  color: black;
  padding: 1rem 0;
  text-align: center;
  margin-top: auto;
}

.footer .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  width:95vw;
  gap: 1rem;
}

.footer span:last-child {
  cursor: pointer;
  text-decoration: underline;
  color: #0a5162;
}

.footer span:last-child:hover {
  color: #3498db;
}

/* Content padrão para páginas normais */
.content {
  display: block;
  width: 100%;
  min-height: 60vh;
  padding: 0;
  background-color: #ffefbc;
  flex: 1;
}

/* Content expandido para PrivacyPolicyPage */
.expanded-content {
  min-height: auto;
  height: auto;
}

@media (max-width: 922px) {
  .displayed {
    display: block;
  }
  
  .menu {
    display: none;
    text-align: center;
    background-color: #f4cf5e; 
    padding: 2vh 0;
    font-family: 'Abhaya Libre';
    font-weight: bold;
    font-size: 10px;
    width: 100vw; /* Alterado de 60vw para 100vw */
    position: fixed;
    top: 50px; /* Posicionar abaixo do ícone do menu */
    left: 0;
    z-index: 1000;
    margin: 0;
    flex-direction: column;
  }
  
  .left-align {
    position: fixed;
    top: 10px;
    left: 10px;
    z-index: 1001;
  }
  .item_menu {
    display: block;
    padding: 1vh 0;
    cursor: pointer;
    font-family: 'Abhaya Libre';
    font-weight: bold;
    font-size: 2em;
  }
  
  .item_menu a {
    text-decoration: none;
    color: #000;
  }
  
  .item_menu:hover {
    background-color: #ffefbc;
    opacity: 0.8;
    border-radius: 5px;
  }
  
  .content {
    min-height: 50vh;
    margin-top:6vh;
  }
  
  .footer .container {
    flex-direction: column;
  }
  
  .copyright {
    font-size: 12px;
  }
}

@media (min-width: 922px) {
  .mobile-header {
    display: none;
  }
  
  .displayed {
    display: none;
  }
  
  .menu {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2vh 0;
    font-family: 'Abhaya Libre';
    font-weight: bold;
    font-size: 2vi;
  }
  
  .item_menu {
    display: inline-block;
    padding: 15px 15px;
    cursor: pointer;
    font-family: 'Abhaya Libre';
    font-weight: bold;
    font-size: 2vi;
  }
  
  .item_menu a {
    text-decoration: none;
    color: #000;
  }
  
  .item_menu:hover {
    background-color: #ffefbc;
    opacity: 0.8;
    border-radius: 5vi;
  }
  
  .content {
    height: auto;
    min-height: 70vh;
    margin-top: 0;
  }
}
</style>